import React, { Component } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import { SuperAdminAction } from "../../Actions";
import Loader from "../Loader/Loader";
import {
  scroolToTop,
  tableHeightScrollBars,
  utcToSpecificTimeZone,
} from "../helper";
import { highSecurityActionList } from "./highSecurityActionsList";
import { highSecurityPageList } from "./highSecurityPageList";

class ActivityLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      page: 1,
      Norow: 100,
      searchValue: "",
      count: 0,
      finalTableHeight: 0,
      activityList: [],
    };
    this.customStyles = {
      table: {
        style: {
          maxHeight: "100% !important",
        },
      },
      rows: {
        style: {
          minHeight: "initial !important",
          maxHeight: "initial !important",
          height: "auto !important", // override the row height
          padding: "10px 0 !important",
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          height: "100%",
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };
    this.columns = [
      {
        name: "Time",
        sortable: true,
        width: "150px",
        cell: (row) => (
          <div>
            {" "}
            {row.created_at
              ? utcToSpecificTimeZone(this.props.timezone, row.created_at)
              : "-"}
          </div>
        ),
        selector: (row) => row?.created_at,
      },
      {
        name: "User",
        sortable: true,
        width: "150px",
        cell: (row) => (
          <div> {row.action_by_name ? row.action_by_name : "-"}</div>
        ),
        selector: (row) => row?.user,
      },
      {
        name: "Site",
        sortable: true,
        width: "150px",
        cell: (row) => <div> {row?.site_name ? row?.site_name : "-"}</div>,
        selector: (row) => row?.site_name,
      },
      {
        name: "Page",
        sortable: true,
        width: "200px",
        cell: (row) => (
          <div> {row.page ? highSecurityPageList[row.page] : "-"}</div>
        ),
        selector: (row) => row?.page,
      },
      {
        name: "Action",
        width: "200px",
        cell: (row) => (
          <div> {row.action ? highSecurityActionList[row.action] : "-"}</div>
        ),
        selector: (row) => row?.action,
      },
      {
        name: "Status",
        sortable: true,
        width: "200px",
        cell: (row) => {
          return row.status && row.status === "Success" ? (
            <div className="text-success">{row.status}</div>
          ) : (
            <div className="text-danger">{row.status}</div>
          );
        },
        selector: (row) => row?.status,
      },
    ];

    this.expandedComponent = ({ data }) => {
      return (
        <div className="extend-row">
          <div className="d-flex flex-column">
            {" "}
            {data.action_additional_details ? this.showDetails(data) : "-"}
          </div>
        </div>
      );
    };
  }

  componentDidMount = async () => {
    this.setState(
      {
        loader: true,
      },
      async () => {
        await this.props.getUsersActivityLogs(
          this.props.PropertyId,
          this.props.timezone
        );
        const selectedPropertyName = this.props.property?.property_name;
        const selectedDomainName = this.props.property?.domain;
        await this.props.setDomainHeader(
          selectedPropertyName,
          selectedDomainName
        );
        this.setState(
          {
            activityList:
              this.props.user_activity_logs &&
              this.props.user_activity_logs.rows &&
              this.props.user_activity_logs.rows.length
                ? JSON.parse(JSON.stringify(this.props.user_activity_logs.rows))
                : [],
            api_response: this.props.api_response,
            count: this.props.user_activity_logs.count,
          },
          () => {
            const height = tableHeightScrollBars();
            this.setState({
              finalTableHeight: height,
              loader: false,
            });
          }
        );
      }
    );
  };

  convertKey = (key) => {
    const ketToValue = {
      parking_spot: "Parking Note",
      ip_addr: "Ip address",
      entry_cam: "Camera at entry",
    };
    return ketToValue[key] ? ketToValue[key] : this.capitalizeFirstLetter(key);
  };

  capitalizeFirstLetter = (string) => {
    const str = string.replaceAll("_", " ");
    return str.replaceAll("_", " ").charAt(0).toUpperCase() + str.slice(1);
  };

  updateDetailShow = (heading, obj) => {
    return (
      <>
        {heading && <h5>{heading}</h5>}
        {Object.keys(obj).length > 0 && (
          <table
            style={{ maxWidth: "400px", tableLayout: "auto", fontSize: "13px" }}
          >
            <thead>
              <tr style={{ borderBottom: "1px solid black" }}>
                <th>Updated Columns</th>
                <th>Old</th>
                <th>New</th>
              </tr>
            </thead>
            {Object.keys(obj).map((x) => (
              <tr key={x}>
                <td>
                  <b>{this.convertKey(x)}</b>
                </td>
                <td>{obj[x].old_value?.toString()}</td>
                <td>{obj[x].new_value?.toString()}</td>
              </tr>
            ))}
          </table>
        )}
      </>
    );
  };

  displayCopySettings = (heading, arr) => {
    return (
      <>
        {heading && <h5>{heading}</h5>}
        {arr.map((x) => this.capitalizeFirstLetter(x)).join(", ")}
      </>
    );
  };

  arr1 = [
    "ADD_UNIT",
    "UPDATE_UNIT",
    "REMOVE_UNIT",
    "ADD_PERMIT",
    "ADD_QUICK_PERMIT",
    "UPDATE_PERMIT",
    "DEACTIVATE_PERMIT",
    "CWH_ACTIVATED",
    "CWH_DEACTIVATED",
    "SCAN_PLATE",
    "PLATE_CHECK",
    "PLATE_AUDIT_CHECK_LPR",
    "PLATE_AUDIT_CHECK_PERMITS",
    "PLATE_SEND_MAIL_PERMIT",
    "ADD_CITATION",
    "CLOSE_CITATION",
    "REOPEN_CITATION",
    "SAVE_CITATION_PDF",
    "SAVE_CITATION_PNG",
    "SEND_PDF_PNG_MAIL_CITATION",
    "VIEW_LAST_CITATION",
    "UPDATE_TICKET_STATUS",
    "ADD_LANE",
    "UPDATE_LANE",
  ];

  arr2 = [
    "DELETE_LANE",
    "ADD_LOT",
    "UPDATE_LOT",
    "DELETE_LOT",
    "ADD_EDGE_DEVICE",
    "UPDATE_EDGE_DEVICE",
    "DELETE_EDGE_DEVICE",
    "ADD_CAMERA",
    "UPDATE_CAMERA",
    "DELETE_CAMERA",
    "ADD_PROPERTY",
    "UPDATE_PROPERTY",
    "DELETE_PROPERTY",
    "ADD_USER",
    "UPDATE_USER",
    "DELETE_USER",
    "OPEN_STREAM",
    "CLOSE_STREAM",
    "COPY_SETTING",
    "UPDATE_PERMISSIONS",
    "SEND_CHAT_MSG",
  ];

  showDetails = (actionObj) => {
    let activityDetails = " - ";
    const action = actionObj.action;
    const actionDetailsData = actionObj.action_additional_details
      ? JSON.parse(actionObj.action_additional_details)
      : {};
    if (actionDetailsData && Object.keys(actionDetailsData).length) {
      if (this.arr1.includes(action)) {
        switch (action) {
          case "ADD_UNIT":
            activityDetails = `Added Unit - ${actionDetailsData.suite_id}`;
            break;
          case "UPDATE_UNIT":
            activityDetails = this.updateDetailShow(
              `Updated unit - ${actionDetailsData.suite_id}`,
              actionDetailsData.update_details
            );
            break;
          case "REMOVE_UNIT":
            activityDetails = `Deleted Unit - ${actionDetailsData.suite_id}`;
            break;
          case "ADD_PERMIT":
            activityDetails = `Added Permit - ${actionDetailsData.permit_tag}`;
            break;
          case "ADD_QUICK_PERMIT":
            activityDetails = `Added Quick Permit - ${actionDetailsData.permit_tag}`;
            break;
          case "UPDATE_PERMIT":
            activityDetails = this.updateDetailShow(
              `Updated Permit - ${actionDetailsData.permit_tag}`,
              actionDetailsData.update_details
            );
            break;
          case "DEACTIVATE_PERMIT":
            activityDetails = `Deactivated Permit - ${actionDetailsData.permit_tag}`;
            break;
          case "CWH_ACTIVATED":
            activityDetails = `CWH Activated - ${actionDetailsData.permit_tag}`;
            break;
          case "CWH_DEACTIVATED":
            activityDetails = `CWH Deactivated - ${actionDetailsData.permit_tag}`;
            break;
          case "SCAN_PLATE":
            activityDetails = `Scan Plate - ${actionDetailsData.lpn}`;
            break;
          case "PLATE_CHECK":
            activityDetails = `Plate Check - ${actionDetailsData.lpn}`;
            break;
          case "PLATE_AUDIT_CHECK_LPR":
            activityDetails = `Plate Audit - ${actionDetailsData.lpn}`;
            break;
          case "PLATE_AUDIT_CHECK_PERMITS":
            activityDetails = `Plate Audit - ${actionDetailsData.lpn}`;
            break;
          case "PLATE_SEND_MAIL_PERMIT":
            activityDetails = `Send Permit email for plate - ${actionDetailsData.lpn}`;
            break;
          case "ADD_CITATION":
            activityDetails = `Added Citation - ${actionDetailsData.ticket_no}`;
            break;
          case "CLOSE_CITATION":
            activityDetails = `Close Citation - ${actionDetailsData.ticket_no}`;
            break;
          case "REOPEN_CITATION":
            activityDetails = `Reopen Citation - ${actionDetailsData.ticket_no}`;
            break;
          case "SAVE_CITATION_PDF":
            activityDetails = `Save Citation Pdf - ${actionDetailsData.ticket_no}`;
            break;
          case "SAVE_CITATION_PNG":
            activityDetails = `Save Citation Png - ${actionDetailsData.ticket_no}`;
            break;
          case "SEND_PDF_PNG_MAIL_CITATION":
            activityDetails = `Send Citation Mail - ${actionDetailsData.ticket_no}`;
            break;
          case "VIEW_LAST_CITATION":
            activityDetails = `View Last Citation - ${actionDetailsData.ticket_no}`;
            break;
          case "UPDATE_TICKET_STATUS":
            activityDetails = `Update Ticket Status For - ${actionDetailsData.ticket_no}`;
            break;
          case "ADD_LANE":
            activityDetails = `Add Lane - ${actionDetailsData.alias}`;
            break;
          case "UPDATE_LANE":
            activityDetails = this.updateDetailShow(
              `Updated lane : ${actionDetailsData.alias}`,
              actionDetailsData.update_details
            );
            break;
          default:
            activityDetails = "";
        }
      }
      if (this.arr2.includes(action)) {
        switch (action) {
          case "DELETE_LANE":
            activityDetails = `Delete Lane - ${actionDetailsData.alias}`;
            break;
          case "ADD_LOT":
            activityDetails = `Add Lot - ${actionDetailsData.alias}`;
            break;
          case "UPDATE_LOT": {
            activityDetails = this.updateDetailShow(
              `Updated lot - ${actionDetailsData.alias}`,
              actionDetailsData.update_details
            );
            break;
          }
          case "DELETE_LOT":
            activityDetails = `Delete Lot - ${actionDetailsData.alias}`;
            break;
          case "ADD_EDGE_DEVICE":
            activityDetails = `Add edge device - ${actionDetailsData.device_name}`;
            break;
          case "UPDATE_EDGE_DEVICE":
            activityDetails = this.updateDetailShow(
              `Updated edge device - ${actionDetailsData.device_name}`,
              actionDetailsData.update_details
            );
            break;
          case "DELETE_EDGE_DEVICE":
            activityDetails = `Delete edge device - ${actionDetailsData.device_name}`;
            break;
          case "ADD_CAMERA":
            activityDetails = `Add Camera - ${actionDetailsData.ip_address}`;
            break;
          case "UPDATE_CAMERA":
            activityDetails = this.updateDetailShow(
              `Updated camera ${actionDetailsData.ip_address}`,
              actionDetailsData.update_details
            );
            break;
          case "DELETE_CAMERA":
            activityDetails = `Delete Camera - ${actionDetailsData.ip_address}`;
            break;
          case "ADD_PROPERTY":
            activityDetails = `Add Property - ${actionDetailsData.site_name}`;
            break;
          case "UPDATE_PROPERTY":
            activityDetails = `Update Settings - ${actionDetailsData.site_name}`;
            break;
          case "DELETE_PROPERTY":
            activityDetails = `Delete Property - ${actionDetailsData.site_name}`;
            break;
          case "ADD_USER":
            activityDetails = `Added User - ${actionDetailsData.username}`;
            break;
          case "UPDATE_USER":
            activityDetails = this.updateDetailShow(
              "Updated user",
              actionDetailsData.update_details
            );
            break;
          case "DELETE_USER":
            activityDetails = `Deleted User - ${actionDetailsData.username}`;
            break;
          case "OPEN_STREAM":
            activityDetails = `Open Stream alias - ${actionDetailsData.alias}`;
            break;
          case "CLOSE_STREAM":
            activityDetails = `Close Stream alias - ${actionDetailsData.alias}`;
            break;
          case "COPY_SETTING":
            activityDetails = this.displayCopySettings(
              `Copy settings from  ${actionDetailsData.site_name}`,
              actionDetailsData.settings
            );
            break;
          case "UPDATE_PERMISSIONS":
            activityDetails = this.updateDetailShow(
              "Updated Permissions",
              actionDetailsData.update_details
            );
            break;
          case "SEND_CHAT_MSG":
            activityDetails = `Send chat message - ${actionDetailsData.ticket_no}`;
            break;
          default:
            activityDetails = "";
        }
      }
    }
    return activityDetails;
  };

  dataTableHandle = (searchValue, searchedActivityList, activityList) => {
    return (
      <DataTable
        data={
          searchValue && searchValue.length
            ? searchedActivityList
            : activityList
        }
        expandableRows
        expandableRowsComponent={this.expandedComponent}
        columns={this.columns}
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        onChangePage={scroolToTop}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={this.state.Norow}
        paginationTotalRows={this.state.count}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  render() {
    const { loader, page, Norow, searchValue, activityList } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="mb-0">
                <Card.Body className="pos-rel-overflow-hide">
                  <>
                    <div className="sidebarFilter"></div>
                    <header>
                      <div className="active-permit-header sm-flex-column sm-align-items-start">
                        <h5 className="mb-2 mb-md-0">List of Activity Logs</h5>
                        <div className="filter-button d-flex flex-wrap">
                          <div className="d-flex align-items-center search-mb-0"></div>
                          <div className="ml-2"></div>
                        </div>
                      </div>
                    </header>
                  </>
                  {loader ? (
                    <Loader />
                  ) : (
                    <>
                      {activityList && (
                        <>
                          <div className="activity-log-table">
                            {this.dataTableHandle(
                              searchValue,
                              activityList,
                              activityList,
                              page,
                              Norow
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStatetoProps = ({
  SuperAdminDetails,
  APIResponseDetails,
  UserProfileDetails,
}) => {
  const { user_activity_logs } = SuperAdminDetails;
  const { property_id: PropertyId, timezone, property } = UserProfileDetails;
  const { api_response } = APIResponseDetails;
  return { api_response, PropertyId, user_activity_logs, timezone, property };
};
const mapStateToDispatch = {
  getUsersActivityLogs: SuperAdminAction.getUsersActivityLogs,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStatetoProps, mapStateToDispatch)(ActivityLog);
